// Header height
let headerHeight = 0;
window.addEventListener("load", () => {
  const header = document.querySelector("header");
  headerHeight = header.style.height;
})

// Image Slideshow
// select the prev and next buttons
const slideButtons = document.querySelectorAll("[data-slide-button]");

slideButtons.forEach(button => {
  button.addEventListener("click", () => {
    const offset = button.dataset.slideButton === "next" ? 1 : -1;
    // slideshow is the container of all images
    const slideshow = button
                      .closest("[data-slideshow]")
                      .querySelector("[data-slides-container]");
    const activeSlide = button
                      .closest("[data-slideshow]")
                      .querySelector("[data-slides-container]")
                      .querySelector("[data-active]");
    
    let newIndex = [...slideshow.children].indexOf(activeSlide) + offset;
    let prevIndex = newIndex - 1;
    let nextIndex = newIndex + 1;

    if (newIndex == 0) {
      prevIndex = slideshow.children.length - 1;
    }

    if (newIndex == slideshow.children.length - 1) {
      nextIndex = 0;
    }
    // newIndex will be the last image if no more prev img
    if (newIndex < 0) {
      newIndex = slideshow.children.length - 1;
      prevIndex = newIndex - 1;
      nextIndex = 0;
    }
    // newIndex will the first image if no more next img
    if (newIndex >= slideshow.children.length) {
      newIndex = 0;
      prevIndex = slideshow.children.length - 1;
      nextIndex = newIndex + 1;
    }
   
    console.log("check prevIndex: " + prevIndex);
    console.log("check nextIndex: " + nextIndex);
    slideshow.children[prevIndex].style.transform = "translateX(-10px)";
    slideshow.children[nextIndex].style.transform = "translateX(10px)";
    slideshow.children[newIndex].style.transform = "translateX(0)";
    slideshow.children[newIndex].dataset.active = true;

    delete activeSlide.dataset.active;
  })
})



// Mobile Nav Sidebar Toggle
const navButt = document.querySelector("[data-nav-button]");
const aside = document.querySelector("[data-aside]");

navButt.addEventListener("click", () => {

  let navStatus = aside.dataset.nav.toString();

  if (navStatus === "close") {
    aside.dataset.nav = "open";
  } else {
    aside.dataset.nav = "close";
  }
})

// Mobile Sub-Nav Toggle
const subnavButtons = document.querySelectorAll("[data-subnav-button]");

subnavButtons.forEach(button => {
  button.addEventListener("click", () => {
    const subNav = button.closest("li")
                         .querySelector("[data-subnav]");

    const subNavStatus = subNav.dataset.subnav.toString();
    console.log("Check subnav: " + subNavStatus);
    if (subNavStatus === "close") {
      subNav.dataset.subnav = "open";
    } else {
      subNav.dataset.subnav = "close";
    }
  })
})

// Mobile Level 2 Site Path Home
const pathHomeButtons = document.querySelectorAll("[data-path-home]");

pathHomeButtons.forEach(button => {
  button.addEventListener("click", () => {
    const subNav = button.closest("li")
                         .querySelector("[data-subnav]");

    const subNavStatus = subNav.dataset.subnav.toString();
    if (subNavStatus === "close") {
      subNav.dataset.subnav = "open";
    } else {
      subNav.dataset.subnav = "close";
    }
  })
})

// Mobile Level 3 Site Path {{ link }}
const pathLinkButtons = document.querySelectorAll("[data-path-link]");

pathLinkButtons.forEach(button => {
  button.addEventListener("click", () => {
    const subNav = button.closest("li")
                         .querySelector("[data-subnav]");

    const subNavStatus = subNav.dataset.subnav.toString();
    if (subNavStatus === "close") {
      subNav.dataset.subnav = "open";
    } else {
      subNav.dataset.subnav = "close";
    }
  })
})


// Burger button 
const burgerButtons = document.querySelectorAll("[data-burger]");

burgerButtons.forEach(button => {
  button.addEventListener("click", () => {
    console.log('clicked');
    let burgerStatus = button.dataset.burger.toString();
    if (burgerStatus === "close") {
      button.dataset.burger = "open";
      button.classList.add('active'); // .active let the burger top and bottom use tailwindcss group-[.*] for styling
    } else {
      button.dataset.burger = "close";
      button.classList.remove('active');
    }
  })
})



// Blog - Projects page center first image
const scroller = document.querySelector("[data-projects-scroller]");
const firstProj = document.querySelector("[data-first-project]");
const firstImg = document.querySelector("[data-first-project-img]");

if (scroller && firstProj && firstImg) {
  function addPadding() {
    const imgWidth = firstImg.offsetWidth;
    const scrollerWidth = scroller.offsetWidth;
    const paddingLeftWidth = (scrollerWidth - imgWidth) / 2;
    firstProj.style.paddingLeft = paddingLeftWidth;
  }

  addPadding();

  window.addEventListener("resize", () => {
    addPadding();
  })
}
